
export default ({Vue, store}) => {

  store.$notify = Vue.prototype.$notify;
}
